import React from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '../../components/Modal';
import ModalHeading from '../../components/Modal/ModalHeading';
import ModalForm from '../../components/Modal/ModalForm';
import ModalButtons from '../../components/Modal/ModalButtons';
import classes from './VideoTranscript.module.css';

const TranscriptDetail = ({
  transcript,
  handleEditTranscript,
  handleCloseTranscript,
  selectedTranscriptText,
  setSelectedTranscriptText,
}) => {
  const { t } = useTranslation();
  const [newTranscriptOneText, setNewTranscriptOneText] = React.useState('');
  const [newTranscriptTwoText, setNewTranscriptTwoText] = React.useState('');

  const formattedDate = new Date(transcript.data.createdAt).toLocaleDateString(
    'en-US',
    {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    }
  );

  const formattedTime = new Date(transcript.data.createdAt).toLocaleTimeString(
    'en-US',
    {
      minute: 'numeric',
      hour: 'numeric',
    }
  );

  React.useEffect(() => {
    if (
      transcript.data &&
      transcript.data.transcriptOneText &&
      transcript.data.transcriptTwoText
    ) {
      setNewTranscriptOneText(transcript.data.transcriptOneText);
      setNewTranscriptTwoText(transcript.data.transcriptTwoText);
    }
  }, [transcript]);

  if (
    !(
      transcript.data &&
      transcript.data.transcriptOneUser &&
      transcript.data.transcriptOneUser.name &&
      transcript.data.transcriptTwoUser &&
      transcript.data.transcriptTwoUser.name &&
      transcript.data.transcriptOneText &&
      transcript.data.transcriptTwoText
    )
  ) {
    return '';
  }

  return (
    <Modal show={transcript.status}>
      <ModalHeading
        heading={t('screens.video.transcript.detailTitle', { userOne: transcript.data.transcriptOneUser.name, userTwo: transcript.data.transcriptTwoUser.name })}
      />

      <ModalForm style={{ marginBottom: '2.5rem' }}>
        <div className={classes.transcriptCard_title}>
          <p>{formattedDate + ' ' + formattedTime}</p>
        </div>

        <div className={classes.transcriptData}>
          <div className={classes.transcriptData__user}>
            <h3>{transcript.data.transcriptOneUser.name}</h3>
            {selectedTranscriptText &&
            selectedTranscriptText.status &&
            selectedTranscriptText.user ===
              transcript.data.transcriptOneUser._id ? (
              <div className={classes.transcriptDataEdit}>
                <textarea
                  className={classes.transcriptDataEdit_textBox}
                  rows={8}
                  value={newTranscriptOneText}
                  onChange={(e) => setNewTranscriptOneText(e.target.value)}
                  autoFocus={
                    selectedTranscriptText &&
                    selectedTranscriptText.status &&
                    selectedTranscriptText.user ===
                      transcript.data.transcriptOneUser._id
                  }
                />
                <div>
                  <button
                    type='button'
                    className={classes.transcriptDataEditSave}
                    onClick={(e) => {
                      e.preventDefault();
                      handleEditTranscript(transcript.data._id, {
                        transcriptOneText: newTranscriptOneText,
                      });
                    }}
                  >
                    {t('screens.video.transcript.save')}
                  </button>
                  <button
                    type='button'
                    className={classes.transcriptDataEditClose}
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedTranscriptText({
                        status: false,
                        user: '',
                        text: '',
                      });
                      setNewTranscriptOneText(
                        transcript.data.transcriptOneText
                      );
                    }}
                  >
                    {t('screens.video.transcript.discard')}
                  </button>
                </div>
              </div>
            ) : (
              <div style={{ position: 'relative' }}>
                <p
                  className={classes.transcriptData__user_text}
                  onDoubleClick={() =>
                    setSelectedTranscriptText({
                      status: true,
                      user: transcript.data.transcriptOneUser._id,
                      text: transcript.data.transcriptOneText,
                    })
                  }
                >
                  <span>{transcript.data.transcriptOneText}</span>
                  <button
                    className={classes.transcriptData__user_btn}
                    onClick={() =>
                      setSelectedTranscriptText({
                        status: true,
                        user: transcript.data.transcriptOneUser._id,
                        text: transcript.data.transcriptOneText,
                      })
                    }
                  >
                    {t('screens.video.transcript.editTranscript')}
                  </button>
                </p>
              </div>
            )}
          </div>

          <div className={classes.transcriptData__user}>
            <h3>{transcript.data.transcriptTwoUser.name}</h3>

            {selectedTranscriptText &&
            selectedTranscriptText.status &&
            selectedTranscriptText.user ===
              transcript.data.transcriptTwoUser._id ? (
              <div className={classes.transcriptDataEdit}>
                <textarea
                  className={classes.transcriptDataEdit_textBox}
                  rows={8}
                  // value={selectedTranscriptText.text}
                  // onChange={(e) =>
                  //   setSelectedTranscriptText({
                  //     ...selectedTranscriptText,
                  //     text: e.target.value,
                  //   })
                  // }
                  value={newTranscriptTwoText}
                  onChange={(e) => setNewTranscriptTwoText(e.target.value)}
                  autoFocus={
                    selectedTranscriptText &&
                    selectedTranscriptText.status &&
                    selectedTranscriptText.user ===
                      transcript.data.transcriptTwoUser._id
                  }
                />
                <div>
                  <button
                    className={classes.transcriptDataEditSave}
                    onClick={(e) => {
                      e.preventDefault();
                      handleEditTranscript(transcript.data._id, {
                        transcriptTwoText: newTranscriptTwoText,
                      });
                    }}
                  >
                    {t('screens.video.transcript.save')}
                  </button>
                  <button
                    className={classes.transcriptDataEditClose}
                    onClick={() => {
                      setSelectedTranscriptText({
                        status: false,
                        user: '',
                        text: '',
                      });
                      setNewTranscriptTwoText(
                        transcript.data.transcriptTwoText
                      );
                    }}
                  >
                    {t('screens.video.transcript.close')}
                  </button>
                </div>
              </div>
            ) : (
              <div style={{ position: 'relative' }}>
                <p
                  className={classes.transcriptData__user_text}
                  onDoubleClick={() =>
                    setSelectedTranscriptText({
                      status: true,
                      user: transcript.data.transcriptTwoUser._id,
                      text: transcript.data.transcriptTwoText,
                    })
                  }
                >
                  <span>{transcript.data.transcriptTwoText}</span>
                  <button
                    className={classes.transcriptData__user_btn}
                    onClick={() =>
                      setSelectedTranscriptText({
                        status: true,
                        user: transcript.data.transcriptTwoUser._id,
                        text: transcript.data.transcriptTwoText,
                      })
                    }
                  >
                    {t('screens.video.transcript.editTranscript')}
                  </button>
                </p>
              </div>
            )}
          </div>
        </div>

        <ModalButtons
          submitButtonLabel={t('screens.video.transcript.close')}
          onSubmit={handleCloseTranscript}
        />
      </ModalForm>
    </Modal>
  );
};

export default TranscriptDetail;
